import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card"
}
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-toolbar" }
const _hoisted_4 = {
  class: "d-flex justify-content-end",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_5 = { class: "svg-icon svg-icon-2" }
const _hoisted_6 = { class: "card-body pt-0" }
const _hoisted_7 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_8 = {
  key: 1,
  class: "badge badge-light-danger"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "svg-icon svg-icon-3" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "svg-icon svg-icon-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_ctx.can('read', 'ads'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_ctx.can('create', 'ads'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-primary",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goTo('ads-brokerage-creating')))
                  }, [
                    _createElementVNode("span", _hoisted_5, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotone/Navigation/Plus.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.translate('addNewAreaConfiguration')), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Datatable, {
            "table-data": _ctx.tableData,
            "table-header": _ctx.tableHeader,
            loading: _ctx.loading,
            "rows-per-page": 10,
            total: _ctx.totalItems,
            "enable-items-per-page-dropdown": false,
            onCurrentChange: _ctx.pageChanged
          }, {
            "cell-id": _withCtx(({ row: adsBrokerage }) => [
              _createTextVNode(_toDisplayString(adsBrokerage.id), 1)
            ]),
            "cell-groupLabel": _withCtx(({ row: adsBrokerage }) => [
              _createTextVNode(_toDisplayString(adsBrokerage.groupLabel), 1)
            ]),
            "cell-groupSlug": _withCtx(({ row: adsBrokerage }) => [
              _createTextVNode(_toDisplayString(adsBrokerage.groupSlug), 1)
            ]),
            "cell-priceRange": _withCtx(({ row: adsBrokerage }) => [
              _createTextVNode(_toDisplayString(adsBrokerage.startingPrice) + " - " + _toDisplayString(adsBrokerage.endingPrice), 1)
            ]),
            "cell-propertyTypeIds": _withCtx(({ row: adsBrokerage }) => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(adsBrokerage.propertyTypeIds, (typeId) => {
                return (_openBlock(), _createElementBlock("span", {
                  class: "badge badge-light-info me-1",
                  key: typeId
                }, _toDisplayString(typeId), 1))
              }), 128))
            ]),
            "cell-areaIds": _withCtx(({ row: adsBrokerage }) => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(adsBrokerage.areaIds, (areaId) => {
                return (_openBlock(), _createElementBlock("span", {
                  class: "badge badge-light-primary me-1",
                  key: areaId
                }, _toDisplayString(areaId), 1))
              }), 128))
            ]),
            "cell-sizes": _withCtx(({ row: adsBrokerage }) => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(adsBrokerage.sizes, (size) => {
                return (_openBlock(), _createElementBlock("span", {
                  class: "badge badge-light-warning me-1",
                  key: size
                }, _toDisplayString(size), 1))
              }), 128))
            ]),
            "cell-isActive": _withCtx(({ row: adsBrokerage }) => [
              (adsBrokerage.isActive)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.translate('active')), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.translate('inactive')), 1))
            ]),
            "cell-actions": _withCtx(({ row: adsBrokerage }) => [
              _createElementVNode("a", {
                href: "#",
                class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1",
                onClick: _withModifiers(($event: any) => (_ctx.editAdsBrokerage(adsBrokerage.id)), ["prevent"])
              }, [
                _createElementVNode("span", _hoisted_10, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/art/art005.svg" })
                ])
              ], 8, _hoisted_9),
              (_ctx.can('remove', 'ads'))
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: "#",
                    class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm",
                    onClick: _withModifiers(($event: any) => (_ctx.toggleStatusAdsBrokerage(adsBrokerage)), ["prevent"])
                  }, [
                    _createElementVNode("span", _hoisted_12, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen019.svg" })
                    ])
                  ], 8, _hoisted_11))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["table-data", "table-header", "loading", "total", "onCurrentChange"])
        ])
      ]))
    : _createCommentVNode("", true)
}